module.exports = __webpack_public_path__ + "img/202402_05.68968eed.jpg";